import { put, takeLatest, call } from 'redux-saga/effects'
import fetchFromAPI, { getDefaultAutorizedHeaders } from 'helpers/fetchFromApi'
import UrlHelper from 'helpers/url'
import { API_URL_MORTALITY_LIST } from 'constants/index'
import {
  MORTALITY_LIST,
  MORTALITY_LIST_FAILURE,
  MORTALITY_LIST_SUCCESS,
} from './reducer'

function* mortalityList(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(API_URL_MORTALITY_LIST, {
        locus: action.payload.locus,
        startDate: action.payload.startDate,
        endDate: action.payload.endDate,
      }),
    })

    if (!response || !response.error) {
      yield put({ type: MORTALITY_LIST_SUCCESS, payload: response })
    } else {
      yield put({ type: MORTALITY_LIST_FAILURE, error: response.errors })
    }
  } catch (error) {
    console.log('MORTALITY ERROR', error)
  }
}

function* mortalitySaga() {
  yield takeLatest(MORTALITY_LIST, mortalityList)
}

export default mortalitySaga
